export default function getVideoXP(videoLength: number): number {
  return Math.round(videoLength * 2.5)
}
